var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlagRo = function SvgIconFlagRo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    stroke: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.1,
    fill: "#D7D7D7",
    stroke: "#E7E7E7",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2A3379",
    d: "M4 12a7.99 7.99 0 0 0 3.429 6.56V5.44A7.99 7.99 0 0 0 4 11.999"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F1CF30",
    d: "M16.571 5.44A7.96 7.96 0 0 0 12.006 4h-.012a8 8 0 0 0-4.566 1.44v13.12A7.94 7.94 0 0 0 11.992 20h.015a7.95 7.95 0 0 0 4.564-1.44z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BB2034",
    d: "M20 12a7.99 7.99 0 0 0-3.429-6.561V18.56A7.99 7.99 0 0 0 20 12"
  }))));
};
export { SvgIconFlagRo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMS41IiBzdHJva2U9IiNFN0U3RTciLz48Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSI4LjEiIGZpbGw9IiNEN0Q3RDciIHN0cm9rZT0iI0U3RTdFNyIgc3Ryb2tlLXdpZHRoPSIuMiIvPjxwYXRoIGZpbGw9IiMyQTMzNzkiIGQ9Ik00IDEyYTcuOTg1IDcuOTg1IDAgMDAzLjQyOSA2LjU2VjUuNDRBNy45ODYgNy45ODYgMCAwMDQgMTEuOTk5Ii8+PHBhdGggZD0iTTE2LjU3MSA1LjQ0QTcuOTY0IDcuOTY0IDAgMDAxMi4wMDYgNGgtLjAxMmE3Ljk4MiA3Ljk4MiAwIDAwLTQuNTY2IDEuNDR2MTMuMTJBNy45NCA3Ljk0IDAgMDAxMS45OTIgMjBoLjAxNWE3Ljk1IDcuOTUgMCAwMDQuNTY0LTEuNDRWNS40NHoiIGZpbGw9IiNGMUNGMzAiLz48cGF0aCBmaWxsPSIjQkIyMDM0IiBkPSJNMjAgMTJhNy45OSA3Ljk5IDAgMDAtMy40MjktNi41NjFWMTguNTZBNy45ODUgNy45ODUgMCAwMDIwIDEyIi8+PC9nPjwvc3ZnPg==";